module.exports = __webpack_public_path__ + "img/15489a5.jpg";